import type { StateCreator } from 'zustand';
import type { AlertsSlices } from '.';

interface TriggerTemplateSliceState {
  openTemplateModal: boolean;
  openSuccessModal: boolean;
  activeTemplate: string | undefined;
  setOpenTemplateModal: (openTemplateModal: boolean) => void;
  setOpenSuccessModal: (openTemplateModal: boolean) => void;
  setActiveTemplate: (activeTemplate: string | undefined) => void;
  isTriggerCreated: (openSuccessModal: boolean) => void;
}

type StateCreatorTriggerTemplate = StateCreator<AlertsSlices, [['zustand/devtools', never]], [], TriggerTemplateSliceState>;

const createTriggerTemplateSlice: StateCreatorTriggerTemplate = (set) => ({
  openTemplateModal: false,
  openSuccessModal: false,
  activeTemplate: undefined,
  setOpenTemplateModal: (openTemplateModal) => set({ openTemplateModal }),
  setOpenSuccessModal: (openSuccessModal) => set({ openSuccessModal }),
  setActiveTemplate: (activeTemplate) => set({ activeTemplate }),
  isTriggerCreated: (openSuccessModal: boolean) => {
    set({
      activeTemplate: undefined,
      openTemplateModal: false,
      openSuccessModal,
    });
  },
});

export type { TriggerTemplateSliceState };
export default createTriggerTemplateSlice;
